import { useState } from 'react';
import { performLogin, clearError } from '../store/slices/authSlice';
import { useAppDispatch, useAppSelector } from '../store/hooks';

export default function Login() {
  const dispatch = useAppDispatch();
  const { loading, error } = useAppSelector(state => state.auth);

  const [id,       setId]       = useState('');
  const [passwd, setPasswd] = useState('');
  const [signupPopup, setSignupPopup] = useState(false);

  const handleSignup = () => {
    setSignupPopup(true);
    // window.open('https://smpm-partners--test-9jslfcqp.web.app', '_blank');
    // window.open('https://smpm-partners.web.app', '_blank');
  };

  const handleSignupClose = () => {
    setSignupPopup(false);
    window.open('https://smpm-partners.web.app', '_blank');
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(clearError());
    dispatch(performLogin({ id, passwd }));
  };

  return (
    <>
      {/* 로딩 오버레이 — flex 컨테이너 밖에 위치시켜 레이아웃에 영향을 주지 않습니다. */}
      {loading && (
        <div className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-4 bg-[#09090e]/80 backdrop-blur-sm">
          {/* 스피너 */}
          <div className="relative w-12 h-12">
            <div className="absolute inset-0 rounded-full border-2 border-[#252530]" />
            <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-[#ff2d55] animate-spin" />
          </div>
          <p className="text-[#7c7c9a] text-xs font-mono tracking-widest uppercase">
            로그인 중...
          </p>
        </div>
      )}

      <div className="min-h-screen flex items-center justify-center bg-[#09090e]">
      <div className="w-full max-w-sm flex flex-col gap-8">

        {/* 로고 */}
        <div className="flex flex-col items-center gap-2">
          <div className="flex items-center gap-2">
            <span className="text-[#ff2d55] text-xl">▶</span>
            <span className="text-white text-xl font-bold tracking-tight">틀어봐</span>
          </div>
        </div>

        {/* 카드 */}
        <div className="bg-[#0f0f16] border border-[#252530] rounded-2xl flex flex-col gap-6" style={{ padding: '40px' }}>

          {/* 헤더 */}
          <div className="flex flex-col gap-1">
            <h1 className="text-white text-lg font-bold tracking-tight text-center">로그인</h1>
            <p className="text-[#8888aa] text-xs text-center">계정에 로그인하세요</p>
          </div>

          {/* 에러 */}
          {error && (
            <p className="text-[#ff2d55] text-xs font-mono">{error}</p>
          )}

          {/* 폼 */}
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">

            {/* 아이디 */}
            <div className="flex flex-col gap-1.5">
              <label
                htmlFor="id"
                className="text-[#dddddd] text-xs font-mono tracking-wider uppercase"
              >
                아이디
              </label>
              <input
                id="id"
                type="text"
                autoComplete="username"
                placeholder="아이디를 입력하세요"
                value={id}
                onChange={(e) => setId(e.target.value)}
                required
                className="w-full rounded-lg border border-[#252530] bg-[#17171f] px-4 py-2.5 text-sm text-[#eeeef5] placeholder-[#4a4a62] font-mono outline-none transition-all focus:border-[#00d4ff] focus:ring-2 focus:ring-[#00d4ff]/10"
              />
            </div>

            {/* 비밀번호 */}
            <div className="flex flex-col gap-1.5">
              <label
                htmlFor="password"
                className="text-[#dddddd] text-xs font-mono tracking-wider uppercase"
              >
                비밀번호
              </label>
              <input
                id="password"
                type="password"
                autoComplete="current-password"
                placeholder="••••••••"
                value={passwd}
                onChange={(e) => setPasswd(e.target.value)}
                required
                className="w-full rounded-lg border border-[#252530] bg-[#17171f] px-4 py-2.5 text-sm text-[#eeeef5] placeholder-[#4a4a62] font-mono outline-none transition-all focus:border-[#00d4ff] focus:ring-2 focus:ring-[#00d4ff]/10"
              />
            </div>

            {/* 로그인 버튼 */}
            <button
              type="submit"
              disabled={loading}
              className="mt-2 w-full rounded-lg bg-[#ff2d55] py-2.5 text-sm font-semibold text-white transition-all hover:opacity-85 active:scale-[0.98] cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? '로그인 중...' : '로그인'}
            </button>

            {/* 회원가입하기 버튼 */}
            <button
              type="button"
              onClick={handleSignup}
              className="w-full rounded-lg border border-[#252530] bg-transparent py-2.5 text-sm font-semibold text-[#8888aa] transition-all hover:border-[#00d4ff] hover:text-[#00d4ff] active:scale-[0.98] cursor-pointer"
            >
              회원가입하기
            </button>

            {/* 이용 가이드 버튼 */}
            <button
              type="button"
              onClick={() => window.open('https://summitplay.notion.site/Play-Some-Tunes-34f77dadb82080a5a4edc29f483d71f4?source=copy_link', '_blank')}
              className="w-full rounded-lg border border-[#252530] bg-transparent py-2.5 text-sm font-semibold text-[#8888aa] transition-all hover:border-[#00d4ff] hover:text-[#00d4ff] active:scale-[0.98] cursor-pointer"
            >
              이용 가이드
            </button>
          </form>
        </div>

        {/* 회원가입 안내 팝업 */}
        {signupPopup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
            <div className="bg-[#0f0f16] border border-[#252530] rounded-2xl flex flex-col items-center gap-6 p-8 w-80">
              <p className="text-white text-sm font-semibold text-center leading-relaxed">
                회원가입후 로그인 해주세요
              </p>
              <button
                onClick={() => handleSignupClose()}
                className="w-full rounded-lg bg-[#ff2d55] py-2.5 text-sm font-semibold text-white transition-all hover:opacity-85 active:scale-[0.98] cursor-pointer"
              >
                확인
              </button>
            </div>
          </div>
        )}

        {/* 하단 힌트 */}
        <p className="text-center text-[#4a4a62] text-xs font-mono tracking-wider">
          SUMMITPLAY
        </p>
      </div>
      </div>
    </>
  );
}
